import { useLocation } from 'react-router-dom';
import { useContext, useEffect, useMemo, useState } from 'react';
import { PaymentContext } from '@bingads-webui-cc-react/payment-context';

import { DEFAULT_ACTIVITY } from '../helpers';

export const useUrlCoupon = (activity = DEFAULT_ACTIVITY) => {
  const [urlCoupon, setUrlCoupon] = useState(null);

  // No IE support https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams
  const { search } = useLocation();
  const query = useMemo(() => new URLSearchParams(search), [search]);

  const isValidUrlCoupon = !!(urlCoupon && urlCoupon.couponString);
  const { paymentContext } = useContext(PaymentContext);

  useEffect(() => {
    // Get coupon value from context/URL
    let { cco, ccl } = paymentContext || {};
    activity.trace(`Coupon in paymentContext cco: ${cco}, ccl: ${ccl}`);
    if (!cco && !ccl) {
      // try getting from Url
      cco = query.get('cco');
      ccl = query.get('ccl');
      activity.trace(`Coupon in URL cco: ${cco}, ccl: ${ccl}`);
    }

    if (cco || ccl) {
      setUrlCoupon({
        couponString: cco || ccl,
        couponStringType: cco ? 'cco' : 'ccl',
      });
    } else {
      setUrlCoupon(null);
    }
  }, [paymentContext, query, activity]);

  return { urlCoupon, isValidUrlCoupon };
};
